<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item :label="$t('分类名称')" prop="categoryName" >
        <a-input v-model="form.categoryName" :maxLength="50" :placeholder="$t('请输入')+$t('分类名称')" >
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['categoryName']"
            input-type="input"
            table-name="goods_goods_category"
            table-field="categoryName"
            :field-value="form.categoryName"/>
        </a-input>
      </a-form-model-item>
      <a-form-model-item :label="$t('分类图片')" prop="categoryPic">
        <oss-upload-single :height="100" :width="100"  v-model="form.categoryPic" prefix="goods" type="img"/>
        <span>推荐尺寸 60 x 60</span>
      </a-form-model-item>
<!--      <a-form-model-item :label="$t('上级分类')" prop="pid" >
        <a-tree-select v-model="form.pid" style="width: 100%" :disabled="userInfo.deptType===2"
                       :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="cateOptions" :placeholder="this.$t('请选择')+this.$t('上级分类')"
                       :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
                       tree-default-expand-all>
        </a-tree-select>
      </a-form-model-item>-->
      <a-form-model-item :label="$t('是否显示')" prop="isVisible" >
        <a-radio-group v-model="form.isVisible" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('是否首页展示')" prop="isHomeVisible" >
        <a-radio-group v-model="form.isHomeVisible" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="关键词" prop="keyWord" >
        <a-input v-model="form.keyWord" type="textarea" :maxLength="500" :placeholder="$t('请输入')+'关键词'" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" type="textarea" :maxLength="500" :placeholder="$t('请输入')+'备注'" />
      </a-form-model-item>
<!--      <a-form-model-item :label="$t('是否参与筛选')" prop="isFilter" >
        <a-radio-group v-model="form.isFilter" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>-->
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {
  getCategory,
  addCategory,
  updateCategory,
  merchantCategoryTree, merchantIdCategoryTree
} from '@/api/goods/category'
import {mapGetters} from 'vuex'
import {generateFilePath,uploadOss, uploadObject} from "@/api/tool/oss";
import CustomDictTag from "@/components/DictCustomTag";
import {translation} from "@/api/tool/common";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssUploadSingle,
    LocaleFieldButton,
    CustomDictTag,
  },
  data () {
    return {
      errorMessage:undefined,
      localeColumns: [
        {
          title: this.$t('语言'),
          dataIndex: 'locale',
          key: 'locale',
          scopedSlots: { customRender: 'locale' }
        }, {
          title: this.$t('分类名称'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'categoryName' },
          key: 'name'
        }, {
          title: this.$t('操作'),
          dataIndex: 'action',
          key: 'action',
          slots: { title: 'addbtn', customRender: 'name' },
          scopedSlots: { customRender: 'action' }
        }
      ],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      cateOptions: [],
      loading: null,
      imgCaseList: [],
      // 表单参数
      form: {
        id: null,
        categoryName: null,
        localeList: [],
        categoryPic: null,
        goodsType:1,
        pid: null,
        level: null,
        keyWord: null,
        isVisible: null,
        isFilter: null,
        isHomeVisible: null,
        sort: null,
        remark: null,
        localeFieldMap: {},

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        categoryName: [
          { required: true, message: this.$t('分类名称')+this.$t('不能为空'), trigger: 'blur' }
        ],
        pid: [
          { required: true, message:  this.$t('上级分类')+this.$t('不能为空'), trigger: 'change' }
        ],
        goodsType: [
          { required: true, message:  '商品分类'+this.$t('不能为空'), trigger: 'change' }
        ],
        categoryPic: [
          { required: false, message:  this.$t('分类图片')+this.$t('不能为空'), trigger: 'blur' }
        ],
        isVisible: [
          { required: true, message:  this.$t('是否显示')+this.$t('不能为空'), trigger: 'blur' }
        ],
        isHomeVisible: [
          { required: true, message:  this.$t('是否首页显示')+this.$t('不能为空'), trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict','userInfo']),
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.cateOptions = []
      this.form = {
        id: null,
        categoryName: null,
        categoryPic: null,
        pid: null,
        goodsType:1,
        level: null,
        isFilter: null,
        isVisible: null,
        keyWord: null,
        isHomeVisible: null,
        sort: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},
      }

    },
    /*getCateList() {
      listCategory({level: 1}).then(response => {
        const cate = { id: "0", categoryName: this.$t('根节点') }
        /!*cate.children = this.handleTree(response.data, 'id','pid')*!/
        this.cateOptions.push(cate)
        response.data.forEach(e=>{
          this.cateOptions.push(e)
        })
      })
    },*/
    getCateList() {
      /*这个方法是树的写法*/
      merchantIdCategoryTree({"maxLevel":1}).then(response => {
        const cate = { id: "0", categoryName: this.$t('根节点'), children: [] }
        this.cateOptions=response.data
        this.cateOptions.unshift(cate)
      })
    },
    /** 新增按钮操作 */
    handleAdd (pid) {
      this.reset()
      this.getCateList();
      this.form.isFilter=false
      this.form.isHomeVisible=true
      this.form.isVisible=true;
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
      if (pid) {
        this.form.pid=pid
      } else {
        this.form.pid="0"
      }

    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.getCateList();

      this.formType = 2
      const id = row ? row.id : ids
      getCategory({"id":id}).then(response => {
        this.form = response.data
        this.open = true;
        this.formTitle = this.$t('修改')
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },

    limitSort(sort) {
      console.log(sort)
      let val = sort;
      if(val==null||val==undefined||val==''||val<0){
        val=0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.sort = val
    },

    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      }else {
        this.handleImagePreview(file);
      }
    },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },


    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCategory(this.form).then(response => {
              this.$message.success(
                this.$t('修改成功'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCategory(this.form).then(response => {
              this.$message.success(
                this.$t('新增成功'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less">
.imgbox {
  overflow: hidden;
  background-color: #f7f7f7;
  position: relative;
  cursor: pointer;

  width: 104px;
  height: 104px;
  margin: 0 8px 8px 0;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.videomask {
  position: absolute;
  z-index: 10;
  width: 100px;
  height: 100px;
  margin: 0 auto;
  line-height: 100px;
  background: rgba(0, 0, 0, .3);
  text-align: center;

  .icon {
    display: inline-block;
    font-size: 26px !important;
    color: #fff !important;
  }
}
</style>
